export default "__VITE_ASSET__CBaWPTzJ__"